import { render, staticRenderFns } from "./Edit-form.vue?vue&type=template&id=3762878c&scoped=true&"
import script from "./Edit-form.vue?vue&type=script&lang=js&"
export * from "./Edit-form.vue?vue&type=script&lang=js&"
import style0 from "./Edit-form.vue?vue&type=style&index=0&lang=scss&"
import style1 from "./Edit-form.vue?vue&type=style&index=1&id=3762878c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3762878c",
  null
  
)

export default component.exports